/* La Pénombre · maquette « Pétale » : animations et petits comportements, sans dépendance.
   Tout s'arrête si le visiteur a choisi « réduire les animations ». */
(function () {
  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var souris = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var observe = function (el, entre, sort, marge) {
    if (!('IntersectionObserver' in window)) { entre(); return; }
    new IntersectionObserver(function (es) { es[0].isIntersecting ? entre() : (sort && sort()); }, { rootMargin: marge || '0px' }).observe(el);
  };

  /* Menu du téléphone */
  var burger = document.querySelector('[data-burger]'), tiroir = document.querySelector('[data-tiroir]');
  if (burger && tiroir) burger.addEventListener('click', function () {
    var ouvert = tiroir.classList.toggle('ouvert');
    burger.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
  });

  /* Grand titre : chaque mot monte à son tour (les balises <em> sont conservées) */
  var nMot = 0;
  var decouper = function (noeud) {
    Array.prototype.slice.call(noeud.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var morceaux = n.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
        morceaux.forEach(function (m) {
          if (!m) return;
          if (/^\s+$/.test(m)) { frag.appendChild(document.createTextNode(m)); return; }
          var s = document.createElement('span'); s.className = 'mot'; s.style.setProperty('--i', nMot++); s.textContent = m; frag.appendChild(s);
        });
        n.parentNode.replaceChild(frag, n);
      } else if (n.nodeType === 1) decouper(n);
    });
  };
  if (!reduit) document.querySelectorAll('[data-mots]').forEach(function (t) { nMot = 0; decouper(t); });

  /* Blocs animés à l'arrivée : la classe « pret » lance la séquence */
  document.querySelectorAll('[data-anime]').forEach(function (b) {
    if (reduit) { b.classList.add('pret'); return; }
    requestAnimationFrame(function () { requestAnimationFrame(function () { b.classList.add('pret'); }); });
  });

  /* Apparitions au défilement */
  var blocs = document.querySelectorAll('.apparait');
  if (!reduit && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('vu'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    blocs.forEach(function (b) { io.observe(b); });
  } else { blocs.forEach(function (b) { b.classList.add('vu'); }); }

  /* Pétales de cerisier qui tombent, mis en pause hors de l'écran */
  if (!reduit) document.querySelectorAll('[data-petales]').forEach(function (zone) {
    var n = parseInt(zone.getAttribute('data-petales'), 10) || 10;
    if (window.innerWidth < 640) n = Math.ceil(n * .6);
    var hasard = function (a, b) { return a + Math.random() * (b - a); };
    for (var i = 0; i < n; i++) {
      var p = document.createElement('span'); p.className = 'petale';
      var d = hasard(10, 18);
      p.style.cssText = '--x:' + hasard(-5, 100).toFixed(1) + '%;--s:' + hasard(10, 20).toFixed(0) + 'px;--d:' + d.toFixed(1) + 's;--delai:' + (-hasard(0, d)).toFixed(1) + 's;--derive:' + hasard(-80, 140).toFixed(0) + 'px;--rot:' + hasard(160, 520).toFixed(0) + 'deg;--o:' + hasard(.55, .95).toFixed(2);
      p.innerHTML = '<i><svg viewBox="0 0 20 24"><use href="#petale"/></svg></i>';
      zone.appendChild(p);
    }
    /* hauteur de chute = hauteur de la zone (héritée par chaque pétale) */
    var regler = function () { zone.style.setProperty('--chute', (zone.offsetHeight + 80) + 'px'); };
    regler(); window.addEventListener('resize', regler);
    observe(zone, function () { zone.classList.remove('en-pause'); }, function () { zone.classList.add('en-pause'); });
  });

  /* La scène du masque : choix de la lumière, défilement automatique tant qu'on n'a pas choisi */
  var scene = document.querySelector('[data-scene]');
  if (scene) {
    var boutons = scene.querySelectorAll('[data-choix]'), legende = scene.querySelector('.scene-legende');
    var ordre = ['eteint', 'bleu', 'rouge'], auto = !reduit, visible = true, minuterie = 0;
    var choisir = function (nom) {
      scene.setAttribute('data-lumiere', nom);
      scene.querySelectorAll('.scene-image img').forEach(function (im) { im.classList.toggle('actif', im.getAttribute('data-lumiere') === nom); });
      boutons.forEach(function (b) {
        var oui = b.getAttribute('data-choix') === nom;
        b.setAttribute('aria-pressed', oui ? 'true' : 'false');
        if (oui && legende) { legende.innerHTML = b.getAttribute('data-legende'); legende.classList.remove('change'); void legende.offsetWidth; legende.classList.add('change'); }
      });
    };
    boutons.forEach(function (b) { b.addEventListener('click', function () { auto = false; clearInterval(minuterie); choisir(b.getAttribute('data-choix')); }); });
    if (auto) minuterie = setInterval(function () {
      if (!auto || !visible || document.hidden) return;
      var i = ordre.indexOf(scene.getAttribute('data-lumiere'));
      choisir(ordre[(i + 1) % ordre.length]);
    }, 3800);
    observe(scene, function () { visible = true; }, function () { visible = false; });

    /* Perles et carte qui suivent doucement la souris (le futur hero 3D prendra cette place) */
    if (souris && !reduit) {
      var zoneSouris = scene.closest('section') || scene, raf = 0, cx = 0, cy = 0;
      zoneSouris.addEventListener('pointermove', function (e) {
        var r = zoneSouris.getBoundingClientRect();
        cx = ((e.clientX - r.left) / r.width - .5) * 2; cy = ((e.clientY - r.top) / r.height - .5) * 2;
        if (!raf) raf = requestAnimationFrame(function () { raf = 0; scene.style.setProperty('--px', cx.toFixed(3)); scene.style.setProperty('--py', cy.toFixed(3)); });
      });
      zoneSouris.addEventListener('pointerleave', function () { scene.style.setProperty('--px', 0); scene.style.setProperty('--py', 0); });
    }
  }

  /* Halo rose qui suit la souris sur les cartes */
  if (souris && !reduit) document.querySelectorAll('.carte.lumiere').forEach(function (c) {
    c.addEventListener('pointermove', function (e) {
      var r = c.getBoundingClientRect();
      c.style.setProperty('--mx', (e.clientX - r.left) + 'px'); c.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
  });

  /* Vidéo : lecture seulement à l'écran, pause possible */
  document.querySelectorAll('[data-video]').forEach(function (boite) {
    var v = boite.querySelector('video'), btn = boite.querySelector('.btn-pause'), enPause = false;
    if (!v) return;
    var econome = navigator.connection && navigator.connection.saveData;
    if (reduit || econome) { v.removeAttribute('autoplay'); v.pause(); if (btn) btn.hidden = true; return; }
    var src = window.matchMedia('(max-width: 640px)').matches ? v.getAttribute('data-src-tel') : v.getAttribute('data-src-ordi');
    if (src && !v.src) v.src = src;
    var lire = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    if (btn) btn.addEventListener('click', function () {
      enPause = !v.paused; if (enPause) v.pause(); else lire();
      btn.setAttribute('aria-label', enPause ? 'Lire la vidéo' : 'Mettre la vidéo en pause');
      btn.innerHTML = enPause ? '<svg viewBox="0 0 16 16"><path d="M4 2.5v11l9-5.5z"/></svg>' : '<svg viewBox="0 0 16 16"><path d="M4 2h3v12H4zM9 2h3v12H9z"/></svg>';
    });
    observe(boite, function () { if (!enPause) lire(); }, function () { v.pause(); });
  });

  /* Une minute de pénombre, sur un anneau */
  var go = document.querySelector('[data-minuteur]');
  if (go) {
    var t = document.querySelector('[data-temps]'), anneau = document.querySelector('[data-anneau]'), note = document.querySelector('[data-note]'), iv = 0;
    var INIT = note ? note.textContent : '';
    var fmt = function (s) { var m = Math.floor(s / 60), r = s % 60; return m + ':' + (r < 10 ? '0' : '') + r; };
    go.addEventListener('click', function () {
      if (iv) { clearInterval(iv); iv = 0; t.textContent = '10:00'; anneau.style.setProperty('--p', 1); go.textContent = 'Essayer une minute'; note.textContent = INIT; return; }
      var reste = 60; t.textContent = fmt(reste); anneau.style.setProperty('--p', 1);
      go.textContent = 'Arrêter'; note.textContent = 'Fermez les yeux. Le masque compterait pour vous.';
      iv = setInterval(function () {
        reste--; t.textContent = fmt(reste); anneau.style.setProperty('--p', reste / 60);
        if (reste <= 0) { clearInterval(iv); iv = 0; go.textContent = 'Recommencer'; note.textContent = 'Voilà une minute. La séance en dure dix, puis le masque s’éteint seul.'; }
      }, 1000);
    });
  }

  /* Galerie de la fiche, avec fondu */
  var grande = document.querySelector('[data-grande]');
  document.querySelectorAll('[data-vignette]').forEach(function (b) {
    b.addEventListener('click', function () {
      var src = b.getAttribute('data-vignette'), alt = b.querySelector('img').alt;
      document.querySelectorAll('[data-vignette]').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      if (reduit) { grande.src = src; grande.alt = alt; return; }
      grande.classList.add('change');
      setTimeout(function () { grande.src = src; grande.alt = alt; grande.classList.remove('change'); }, 260);
    });
  });

  /* Barre « Prévenez-moi » du téléphone : visible quand le formulaire est passé */
  var barreAchat = document.querySelector('[data-barre-achat]'), ancre = document.querySelector('[data-ancre-achat]');
  if (barreAchat && ancre) {
    var verifier = function () {
      var pied = document.querySelector('.pied'), avant = pied && pied.getBoundingClientRect().top < window.innerHeight;
      barreAchat.classList.toggle('visible', ancre.getBoundingClientRect().bottom < 0 && !avant);
    };
    window.addEventListener('scroll', verifier, { passive: true }); window.addEventListener('resize', verifier); verifier();
  }

  /* Vidéo du haut de page lue au rythme du défilement.
     Fluidité : vidéo encodée avec une image clé toutes les 6 images, une seule demande de position à la fois
     (on attend la fin de la précédente), et un léger amorti vers la position voulue. */
  var defil = document.querySelector('[data-defilement]');
  if (defil) {
    var vid = defil.querySelector('video'), jauge = defil.querySelector('[data-progression]');
    var etapesVideo = [].slice.call(defil.querySelectorAll('[data-plage]')).map(function (e) {
      return { el: e, plages: e.getAttribute('data-plage').split(',').map(function (p) { var a = p.split('-'); return [parseFloat(a[0]), parseFloat(a[1])]; }) };
    });
    var surTel = window.matchMedia('(max-width: 760px)').matches;
    if (surTel && vid.getAttribute('data-affiche-tel')) vid.poster = vid.getAttribute('data-affiche-tel');
    var srcVid = surTel ? vid.getAttribute('data-src-tel') : vid.getAttribute('data-src-ordi'); vid.muted = true; vid.setAttribute('muted', ''); vid.setAttribute('playsinline', ''); /* iPhone : la video est chargee en entier avant le defilement, sinon Safari n'affiche que la premiere image */ if (surTel && window.fetch && window.URL && URL.createObjectURL) { fetch(srcVid).then(function (r) { if (!r.ok) throw new Error('video'); return r.blob(); }).then(function (b) { vid.src = URL.createObjectURL(b); }).catch(function () { vid.src = srcVid; }); } else { vid.src = srcVid; } var deverrouiller = function () { var l = vid.play(); if (l && l.then) l.then(function () { vid.pause(); }).catch(function () {}); }; ['touchstart', 'pointerdown'].forEach(function (ev) { document.addEventListener(ev, deverrouiller, { once: true, passive: true }); });
    var nommer = function (t) {
      etapesVideo.forEach(function (x) { x.el.classList.toggle('actif', x.plages.some(function (p) { return t >= p[0] && t < p[1]; })); });
    };
    nommer(0);
    if (reduit) {
      /* sans animation : la vidéo reste sur sa première image, la page défile normalement */
      defil.classList.add('fixe');
    } else {
      var duree = 0, actuel = 0, tourne = false, visibleDefil = true;
      var avancement = function () {
        var r = defil.getBoundingClientRect(), course = defil.offsetHeight - window.innerHeight;
        return course > 0 ? Math.min(1, Math.max(0, -r.top / course)) : 0;
      };
      var image = function () {
        var p = avancement(), cible = p * Math.max(0, duree - 0.06);
        actuel += (cible - actuel) * 0.2;
        if (Math.abs(cible - actuel) < 0.003) actuel = cible;
        if (duree && !vid.seeking && Math.abs(vid.currentTime - actuel) > 0.015) vid.currentTime = actuel;
        if (jauge) jauge.style.setProperty('--p', p.toFixed(4));
        nommer(actuel);
        defil.classList.toggle('commence', p > 0.02);
        if (visibleDefil && !document.hidden) requestAnimationFrame(image); else tourne = false;
      };
      var lancer = function () { if (!tourne) { tourne = true; requestAnimationFrame(image); } };
      vid.addEventListener('loadedmetadata', function () { duree = vid.duration || 0; lancer(); });
      /* certains téléphones ne chargent les images de la vidéo qu'après une première lecture : on lit puis on met en pause aussitôt */
      vid.addEventListener('loadeddata', function () { var l = vid.play(); if (l && l.then) l.then(function () { vid.pause(); }).catch(function () {}); }, { once: true });
      observe(defil, function () { visibleDefil = true; lancer(); }, function () { visibleDefil = false; });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) lancer(); });
    }
  }

  /* Boutique : apres l'envoi d'un formulaire (liste d'attente, contact), on ramene la page sur le message de confirmation */
  var messageOk = document.querySelector('.message-ok, .message-erreur');
  if (messageOk) messageOk.scrollIntoView({ block: 'center' });

  /* Formulaires factices de la maquette */
  document.querySelectorAll('form[data-factice]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var ok = f.parentNode.querySelector('[data-ok]');
      if (ok) { f.hidden = true; ok.hidden = false; }
    });
  });
})();
